import React, { useState } from 'react';
import Navigation from "../components/Navigation/Navigation";
import FrontendFooter from "../components/Layout/FrontendFooter";
import { Container, Box, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import AboutBanner from "../assets/images/team.jpg";
import NoImage from "../assets/images/no-image.jpg";
import Esuresh from "../assets/images/e-suresh.jpg";


const Team = () => {
  const teamMembers = [
    {
      id: 1,
      name: 'E. Suresh Sharan',
      bio: '',
      image: Esuresh
    },
    {
      id: 2,
      name: 'Praveen Allu',
      bio: '',
      image: NoImage
    },
    {
      id: 3,
      name: 'Sandeep',
      bio: '',
      image: NoImage
    },
  
  ];

  const [flippedCard, setFlippedCard] = useState(null);

  const handleCardHover = (id) => {
    setFlippedCard(id);
  };

  const handleCardLeave = () => {
    setFlippedCard(null);
  };

  return (
    <div className="fp-wrapper app-container">
      <Navigation />
      
      <section className="inner-banner text-white" style={{ backgroundImage: `url(${AboutBanner})` }}>
        <div className="home-container">
          <h1 className="page-title">Our Team</h1>
          <p>Meet the talented professionals who make our success possible</p>
        </div>
      </section>

      <section className="about-section inner-page-content">
        <Container maxWidth="lg">
          <Grid container spacing={4} justifyContent="center">
            {teamMembers.map((member) => (
              <Grid size={{ xs: 12, md: 4 }} key={member.id} className="leader-card-container">
                <div 
                  className="leader-card"
                  onMouseEnter={() => handleCardHover(member.id)}
                  onMouseLeave={handleCardLeave}
                  style={{
                    transform: flippedCard === member.id ? 'rotateY(180deg)' : 'rotateY(0)',
                  }}
                >
                  <div className="leader-card-front">
                    <img 
                      src={member.image} 
                      alt={member.name}
                      className="card-image"
                    />
                    <div className="card-overlay">
                      <Typography variant="h5" component="h3">
                        {member.name}
                      </Typography>
                    
                    </div>
                  </div>
                  
                  <div className="leader-card-back">
                    <h3>{member.name}</h3>
                    <p>{member.bio}</p>
                  </div>
                </div>
              </Grid>
            ))}
          </Grid>
        </Container>
      </section>

      <FrontendFooter />
    </div>
  );
};

export default Team;